var BoundingBoxType;
(function (BoundingBoxType) {
    BoundingBoxType["Circle"] = "circle";
    BoundingBoxType["Rectangle"] = "rectangle";
})(BoundingBoxType || (BoundingBoxType = {}));

export { BoundingBoxType };
